import { Outlet } from '@tanstack/react-router'
import { Sidebar } from '../../components/layout/Sidebar'
import { Header } from '../../components/layout/Header'
import { useAppSelector, useAppDispatch } from '../../store'
import { toggleSidebar } from '../../store/slices/appSlice'
import { useEffect } from 'react'
import { ParticleNetwork } from '../../components/ui/particle-network'

export default function DashboardLayout() {
  const open = useAppSelector((s) => s.app.sidebarOpen)
  const dispatch = useAppDispatch()

  // Handle mobile sidebar auto-close on resize only
  useEffect(() => {
    let initialWidth = window.innerWidth

    const handleResize = () => {
      const currentWidth = window.innerWidth
      // Only close sidebar if we're transitioning from desktop to mobile
      if (initialWidth >= 1024 && currentWidth < 1024 && open) {
        dispatch(toggleSidebar())
      }
      initialWidth = currentWidth
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [dispatch, open])

  return (
    <div className="min-h-screen bg-background relative">
      {/* Particle Network Background */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <ParticleNetwork className="w-full h-full" />
      </div>
      
      <Sidebar open={open} />
      
      {/* Overlay for mobile */}
      {open && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => dispatch(toggleSidebar())}
        />
      )}
      
      <div className={`relative z-10 transition-all duration-300 ${open ? 'lg:ml-64' : 'ml-0'}`}>
        <Header />
        <main 
          className="relative p-4 lg:p-6 min-h-[calc(100vh-3.5rem)]"
        >
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}
